module.exports = __webpack_public_path__ + "static/media/Preloader_1.515ac9e2.gif";